import { useEffect } from 'react';

/**
 * 全局键盘快捷键
 * /: 聚焦搜索
 * Esc: 关闭弹窗/清空搜索
 * Ctrl/Cmd + K: 打开快速命令面板
 */
const KeyboardShortcuts = () => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      // / 键聚焦搜索（非输入框中）
      if (e.key === '/' && !['INPUT', 'TEXTAREA'].includes(e.target.tagName)) {
        e.preventDefault();
        const searchInput = document.querySelector('.sj-global-search, .ant-input-search input, [placeholder*="搜索"]');
        if (searchInput) searchInput.focus();
      }

      // Esc 键：关闭弹窗或清空搜索
      if (e.key === 'Escape') {
        const modals = document.querySelectorAll('.ant-modal-wrap');
        const openModal = Array.from(modals).find(m => m.style.display !== 'none');
        if (openModal) {
          const closeBtn = openModal.querySelector('.ant-modal-close');
          if (closeBtn) closeBtn.click();
        }
      }

      // Ctrl/Cmd + K：打开快速命令面板
      if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
        e.preventDefault();
        // 触发全局命令面板事件
        window.dispatchEvent(new CustomEvent('sj:open-command-palette'));
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return null;
};

export default KeyboardShortcuts;
